import { Button } from "@/components/ui/button";
import type { ComplianceFramework } from "@/types/compliance";

interface FrameworkSelectorProps {
  frameworks: ComplianceFramework[];
  selected: string | null;
  onSelect: (frameworkId: string) => void;
  isLoading: boolean;
}

export function FrameworkSelector({
  frameworks,
  selected,
  onSelect,
  isLoading,
}: FrameworkSelectorProps) {
  if (isLoading) {
    return (
      <div className="flex gap-3">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="h-20 w-44 animate-pulse rounded-lg bg-muted"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-3">
      {frameworks.map((fw) => (
        <Button
          key={fw.framework_id}
          variant={selected === fw.framework_id ? "default" : "outline"}
          className="h-auto flex-col items-start px-4 py-3 text-left"
          onClick={() => onSelect(fw.framework_id)}
        >
          <span className="text-sm font-medium">{fw.name}</span>
          <span className="text-xs opacity-70">
            v{fw.version} &middot; {fw.control_count} controls
          </span>
        </Button>
      ))}
    </div>
  );
}
